// Shared ranking extracted unchanged from primaryLeagueTips.
// Callers decide eligible markets/lines; ranking never manufactures an indication.
export function selectPrimaryTipCandidate(candidates) {
  return (
    [...candidates].sort(
      (a, b) =>
        a.distance - b.distance ||
        b.advantage - a.advantage ||
        String(a.line).localeCompare(String(b.line)) ||
        a.outcome.localeCompare(b.outcome)
    )[0] || null
  );
}
